import { authGuard } from '@/router/guards'

export default
{
    path: '/moderation',
    beforeEnter: authGuard,
    component: () => import('@/wrappers/AdminRoleProvider.vue'),
    children: [
        {
            path: 'games',
            name: 'moderation-games',
            component: () => import('@/Moderation/views/Games/Games.vue'),
        },
    ],
}
